import {
  CLEAR_CREDIT_CARD_DETAILS,
  CREATE_CREDIT_CARD,
  CREATE_CREDIT_CARD_FAIL,
  CREATE_CREDIT_CARD_SUCCESS,
  DELETE_CREDIT_CARD,
  DELETE_CREDIT_CARD_FAIL,
  DELETE_CREDIT_CARD_SUCCESS,
  GET_CREDIT_CARD,
  GET_CREDIT_CARD_FAIL,
  GET_CREDIT_CARD_SUCCESS,
  GET_CREDIT_CARDS,
  GET_CREDIT_CARDS_FAIL,
  GET_CREDIT_CARDS_SUCCESS,
  UPDATE_CREDIT_CARD,
  UPDATE_CREDIT_CARD_FAIL,
  UPDATE_CREDIT_CARD_SUCCESS
} from './constants';

export const creditCardsGet = (payload?) => {
  return {
    type: GET_CREDIT_CARDS,
    payload
  };
};

export const creditCardsGetSuccess = payload => {
  return {
    type: GET_CREDIT_CARDS_SUCCESS,
    payload
  };
};

export const creditCardsGetFail = error => {
  return {
    type: GET_CREDIT_CARDS_FAIL,
    error
  };
};

export const createCreditCard = (payload, onSuccess, onError) => {
  return {
    type: CREATE_CREDIT_CARD,
    payload,
    onSuccess,
    onError
  };
};

export const createCreditCardSuccess = payload => {
  return {
    type: CREATE_CREDIT_CARD_SUCCESS,
    payload
  };
};

export const createCreditCardFail = error => {
  return {
    type: CREATE_CREDIT_CARD_FAIL,
    error
  };
};

export const getCreditCard = payload => {
  return {
    type: GET_CREDIT_CARD,
    payload
  };
};

export const getCreditCardSuccess = payload => {
  return {
    type: GET_CREDIT_CARD_SUCCESS,
    payload
  };
};

export const getCreditCardFail = error => {
  return {
    type: GET_CREDIT_CARD_FAIL,
    error
  };
};

export const updateCreditCard = (payload, onSuccess, onError) => {
  return {
    type: UPDATE_CREDIT_CARD,
    payload,
    onSuccess,
    onError
  };
};

export const updateCreditCardSuccess = payload => {
  return {
    type: UPDATE_CREDIT_CARD_SUCCESS,
    payload
  };
};

export const updateCreditCardFail = error => {
  return {
    type: UPDATE_CREDIT_CARD_FAIL,
    error
  };
};

export const deleteCreditCard = payload => {
  return {
    type: DELETE_CREDIT_CARD,
    payload
  };
};

export const deleteCreditCardSuccess = payload => {
  return {
    type: DELETE_CREDIT_CARD_SUCCESS,
    payload
  };
};

export const deleteCreditCardFail = error => {
  return {
    type: DELETE_CREDIT_CARD_FAIL,
    error
  };
};

export const clearCreditCardDetails = () => {
  return {
    type: CLEAR_CREDIT_CARD_DETAILS
  };
};
